import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2de4ac53"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-customer-wrapper pr-6" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "list-customer-body" }
const _hoisted_4 = ["onClick"]

import { get, set } from "@vueuse/core";
import { inject, onBeforeMount, ref } from "vue";
import { PageState } from "primevue/paginator";
import { DEFAULT_PAGINATOR_ROWS } from "@/clinic/typings/constants/paginator";
import { CustomerDuplicateCheckFields } from "@/clinic/typings/enums/customer";
import RouterUtils from "@/common/utils/router.util";
import RouterConstants from "@/clinic/constants/router.constants";
import Header from "@/clinic/components/atoms/Grid/header.vue";
import Grid from "@/clinic/components/atoms/Grid/index.vue";
import DuplicateCustomerService from "@/clinic/services/duplicate-customer.services";
import Paginator from "@/clinic/components/atoms/Paginator/index.vue";
import MergeDialog from "@/clinic/views/DuplicateCustomer/Dialog/merge.vue";
import RightSideBar from "@/clinic/views/Customer/components/rightSidebar/RightSideBar.vue";

type IColumn = {
  field: string;
  header: string;
  class?: string;
  style?: string;
  icon?: any;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const title = "※類似顧客を統合します。<br>※統合された顧客情報は表示しなくなりますので、ご注意ください。";

const rows = ref(DEFAULT_PAGINATOR_ROWS);
const totalCount = ref(0);
const page = ref(0);
const clinicId = ref(0);
const duplicateCustomers = ref<any[]>([]);
const loading = ref(false);
const mergeDialogVisible = ref(false);
const selectedDuplicateCustomers = ref<any[]>([]);
const selectedPrimaryCustomer = ref<number>(0);
const lineCustomerIds = ref<any[]>([]);
const topPg = ref<InstanceType<typeof Paginator> | null>(null);
const bottomPg = ref<InstanceType<typeof Paginator> | null>(null);
const sidebarVisible = ref(false);
const sidebar = ref<InstanceType<typeof RightSideBar> | null>(null);
const currentCustomerId = ref(0);

const backgroundColors = [
  "FFCCCC",
  "FFE6CC",
  "FFFFCC",
  "E6FFCC",
  "CCFFCC",
  "CCFFE6",
  "CCFFFF",
  "CCE5FF",
  "CCCCFF",
  "FFCCFF",
  "FFCCE6",
];

const columns = ref<IColumn[]>([
  { field: "group_by", header: "類似情報", class: "col-2" },
  { field: "code", header: "カルテNo.", class: "col-1" },
  {
    field: "linked_line",
    header: "LINE紐付け",
    class: "col-1 flex justify-content-center",
    icon: { true: "icon-lms icon-lms_link text-line-green" },
  },
  { field: "name", header: "名前", class: "col-4" },
  { field: "phone", header: "電話番号", class: "col-2" },
  { field: "birthday", header: "生年月日", class: "col-1" },
  { field: "buttons", header: "", class: "col-1 flex justify-content-center" },
]);

const clinicIdParams = async () => ({ clinic_id: get(await get(clinicId)) });

const onItemClick = async (event: any, item: any) => {
  await (currentCustomerId.value = Number.parseInt(item.id));
  get(sidebar)?.onShow();
};

const showMergeDialog = (data: any) => {
  onToggleMergeDialog();
  selectedPrimaryCustomer.value = data;
  selectedDuplicateCustomers.value = duplicateCustomers.value.filter(item => item.group_index == data.group_index);
};
const onToggleMergeDialog = (reloadData?: boolean) => {
  mergeDialogVisible.value = !mergeDialogVisible.value;
  if (reloadData) fetchDuplicateData();
};

const paging = async (_: string, { page: newPage }: PageState) => {
  if (newPage !== page.value) {
    set(duplicateCustomers, []);
    set(page, newPage);
    get(topPg)?.getPagination()?.changePage(newPage);
    get(bottomPg)?.getPagination()?.changePage(newPage);
    await fetchDuplicateData();
  }
};

const fetchDuplicateData = async () => {
  set(loading, true);
  const { data: response } = await DuplicateCustomerService.fetchData(
    { ...(await clinicIdParams()), offset: get(page) * get(rows), limit: get(rows) },
    () => undefined,
    () => undefined
  );
  const { data, total, line_customer_ids } = get(response);
  set(lineCustomerIds, get(line_customer_ids));
  set(duplicateCustomers, buildDuplicateCustomers(get(data)));
  set(totalCount, get(total));
  set(loading, false);
};

const buildDuplicateCustomers = (data: any[]) => {
  return data.flatMap((item, index) => {
    const group_by = item.group_by
      .split("_")
      .map((word: string) => CustomerDuplicateCheckFields[word].jp_name)
      .join("·");

    return item.customers.map((customer: any) => {
      const phone = item.none_group_by === CustomerDuplicateCheckFields.phone.en_name ? customer.phone : item.phone;
      const birthday =
        item.none_group_by === CustomerDuplicateCheckFields.birthday.en_name ? customer.birthday : item.birthday;
      const name = item.none_group_by === CustomerDuplicateCheckFields.name.en_name ? customer.name : item.name;

      return {
        group_index: index,
        group_by: group_by,
        name: name || "",
        phone: phone || "",
        birthday: birthday || "",
        code: customer.code,
        id: customer.id,
        style: `background-color: #${backgroundColors[index]}`,
        linked_line: lineCustomerIds.value.includes(Number.parseInt(customer.id)),
      };
    });
  });
};

onBeforeMount(async () => {
  set(clinicId, await inject("clinicId"));
  await fetchDuplicateData();
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RightSideBar, {
      ref_key: "sidebar",
      ref: sidebar,
      visible: sidebarVisible.value,
      "customer-id": currentCustomerId.value,
      "clinic-id": _unref(get)(clinicId.value)
    }, null, 8, ["visible", "customer-id", "clinic-id"]),
    _createVNode(Header, {
      enableCreate: false,
      enableTitle: "",
      titleLabel: title,
      titleStyle: "white-space: pre-line; line-height: 1.75"
    }, {
      otherButtons: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Button, {
            label: "顧客一覧へ戻る",
            class: "mr-0 btn-orange",
            onClick: _cache[0] || (_cache[0] = () => _unref(RouterUtils).goTo(_unref(RouterConstants).CUSTOMER_ROUTER_NAME))
          })
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      (totalCount.value > rows.value)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 0,
            onPaging: paging,
            totalRecords: totalCount.value,
            rows: rows.value,
            ref_key: "topPg",
            ref: topPg
          }, null, 8, ["totalRecords", "rows"]))
        : _createCommentVNode("", true),
      _createVNode(Grid, {
        items: duplicateCustomers.value,
        columns: columns.value,
        loading: loading.value,
        onOnItemClick: onItemClick
      }, {
        buttons: _withCtx(({ data }) => [
          _createElementVNode("span", {
            onClick: _withModifiers(($event: any) => (showMergeDialog(data)), ["stop"])
          }, "統合顧客を選択", 8, _hoisted_4)
        ]),
        _: 1
      }, 8, ["items", "columns", "loading"]),
      (totalCount.value > rows.value)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 1,
            onPaging: paging,
            totalRecords: totalCount.value,
            rows: rows.value,
            ref_key: "bottomPg",
            ref: bottomPg
          }, null, 8, ["totalRecords", "rows"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(MergeDialog, {
      visible: mergeDialogVisible.value,
      "primary-customer": selectedPrimaryCustomer.value,
      "duplicate-customers": selectedDuplicateCustomers.value,
      "clinic-id": clinicId.value,
      onToggle: onToggleMergeDialog
    }, null, 8, ["visible", "primary-customer", "duplicate-customers", "clinic-id"])
  ]))
}
}

})